<header id="headadmin">
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div class="card-header text-center" style="background-color: #be0c4d;">
      <h5 style="color: white;">Usuarios</h5>
    </div>
    <div class="card-body">
      <div class="btn-toolbar justify-content-between" role="toolbar" aria-label="Toolbar with button groups">
        <div class="d-grid d-md-block">
          <button type="button" class="btn btn-secondary" (click)="nuevoUsuarioCHV()">+ Usuario CHV</button>
          <button type="button" class="btn btn-secondary" (click)="nuevoUsuarioFIVI()">+ Usuario FIVI</button>
          <button type="button" class="btn btn-secondary" (click)="nuevoUsuarioDANE()">+ Usuario DANE</button>
          <button *ngIf="!botonDescarga" type="button" class="btn btn-success" id="exportar" (click)="download()">Generar EXCEL</button>
          <button *ngIf="botonDescarga" type="button" class="btn btn-success" disabled>
            <div class="row">
              <div class="d-flex align-items-center">
                <div style="color: white; margin-right: 5px;">Generar EXCEL </div>
                <div class="spinner-border spinner-border-sm text-light" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          </button>
        </div>
      </div>
      <div id="tabla" class="container-fluid overflow-scroll">
        <!--Tabla de usuarios-->
        <table datatable [dtOptions]="dtOptions"  [dtTrigger]="dtTrigger" class="table table-bordered row-border hover datatable"
           id="table2excel">
          <thead>
            <tr>
              <th scope="col" class="text-center" rowspan="2">Tipo Usuario</th>
              <th scope="col" class="text-center" rowspan="2">Usuario</th>
              <th scope="col" class="text-center" rowspan="2">Código Entidad</th>
              <th scope="col" class="text-center" colspan="3">Responsable Usuario</th>
              <th scope="col" class="text-center" rowspan="2">Estado</th>
              <th scope="col" class="text-center" rowspan="2">Opciones</th>
            </tr>
            <tr>
              <th scope="col" class="text-center">Nombre y Apellidos</th>
              <th scope="col" class="text-center">Teléfono</th>
              <th scope="col" class="text-center">Email</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let usuario of usuarios">
              <td scope="col" >{{usuario.tipoUsuario.nombreTipo}} {{usuario.tipoUsuario.usTipoTipo}}</td>
              <td scope="col" >{{usuario.username}}</td>
              <td scope="col" >
                <div *ngIf="usuario.tipoUsuario.idTipoUsuario==1">--</div>
                <div *ngIf="usuario.tipoUsuario.idTipoUsuario==2">--</div>
                <div *ngIf="usuario.tipoUsuario.idTipoUsuario==3">--</div>
                <div *ngIf="usuario.tipoUsuario.idTipoUsuario==4">{{usuario.fuente.codEnti}}</div>
                <div *ngIf="usuario.tipoUsuario.idTipoUsuario==5">{{usuario.fuente.codEnti}}</div>
                <div *ngIf="usuario.tipoUsuario.idTipoUsuario==6">--</div>
              </td>
              <td scope="col" >{{usuario.nombres}} {{usuario.apellidos}}</td>
              <td scope="col" >{{usuario.telefono}}</td>
              <td scope="col" >{{usuario.correo}}</td>
              <td scope="col" >{{usuario.estadoUsuario.nombreEstado}}</td>
              <td scope="col" class="text-center" id="opciones">
                <div class="container">
                  <div class="row">
                    <div class="col-1" *ngIf="usuario.estadoUsuario.nombreEstado == 'Activo'">
                      <a type="button" class="fa fa-edit" (click)="editarUsuario(usuario.id)" style="color: green;"></a>
                    </div>
                    <div class="col-1" *ngIf="usuario.estadoUsuario.nombreEstado == 'Inactivo'">
                      <a type="button" class="fa fa-edit" style="color: gray;"></a>
                    </div>
                    <div class="col-1">
                      <a type="button" class="fa fa-check-square" (click)="estadoUsuario(usuario)" style="color: gray;"></a>
                    </div>
                    <div class="col-1">
                      <a type="button" class="fa fa-calendar-check" data-toggle="modal" data-target="#modalHistoria" (click)="HistEstadoUsuario(usuario.id)" style="color: blue;"></a>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</body>

<!--inactivar-activar-->
<button class="btn btn-primary btn-sm" #openModalcloseModalActivar data-toggle="modal"  data-target="#modalInActi" style="visibility: hidden;"
 data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-lg" id="modalInActi" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h5 *ngIf="EstadoActual=='2'" class="modal-title" id="modalInActi" style="color: white;">Activar</h5>
        <h5 *ngIf="EstadoActual=='1'" class="modal-title" id="modalInActi" style="color: white;">Inactivar</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <br>
          <div class="container-fluid">
            <div class="row">
              <div class="col-2"><label><b>Usuario :</b></label></div>
              <div class="col-4"><input class="form-control" type="text" name="usuario" [(ngModel)]="UsuarioActivar.username" disabled></div>
            </div>
            <div class="row">
              <div><label><b>Observación</b></label></div>
              <div><textarea type="text" class="table-responsive" rows="4" cols="12" name="observacion" [(ngModel)]="NuevaHistoria.observacion"></textarea></div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" #closeModalcloseModalActivar data-dismiss="modal">Cancelar</button>
        <button *ngIf="!btnguardar" type="button" class="btn btn-primary" (click)="cambiarEstadoUsuario()" [disabled]="btnguardar">Aceptar</button>
        <button *ngIf="btnguardar" type="button" class="btn btn-primary" disabled>
          <div class="row">
            <div class="d-flex align-items-center">
              <div style="color: white; margin-right: 5px;">Aceptar </div>
              <div class="spinner-border spinner-border-sm text-light" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>

<!--Modal confirmar activación-->
<button class="btn btn-primary btn-sm" #openmodalconfirmar data-toggle="modal"  data-target="#modal-confirmar" style="visibility: hidden;"
 data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-md" id="modal-confirmar" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header" id="modalheader" style="background-color: #be0c4d;">
        <h5 class="modal-title" id="ModalLabel" style="color: white;">Confirmar</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" #cerrarmodalconfirmar
              style="visibility: hidden;">
                <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
              </button>
      </div>
      <div class="modal-body">
        <div class="card-body container-fluid">
          <br>
          <div class="row">
            <div *ngIf="EstadoActual == '1'" class="col-auto" style="margin: auto;">
              <h5>Confirmar que desea <b>inactivar</b> al usuario <b>{{nombreUsuarioCambiaEstado}}</b>.</h5>
            </div>
            <div *ngIf="EstadoActual == '2'" class="col-auto" style="margin: auto;">
              <h5>Confirmar que desea <b>activar</b> al usuario <b>{{nombreUsuarioCambiaEstado}}</b>.</h5>
            </div>
          </div>
          <br>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cancelarConfirmar()">Cancelar</button>
        <button type="submit" class="btn btn-primary" (click)="confirmarGuardar()">Guardar</button>
      </div>
    </div>
  </div>
</div>

<!--historial activacion-->
<div class="modal fade bd-example-modal-lg" id="modalHistoria" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h5 class="modal-title" id="modalHistoria">Historia de Activación</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card-body container-fluid overflow-scroll">
          <table class="table table-bordered table-responsive-lg">
            <thead>
              <tr>
                <th scope="col-1" class="text-center">Fecha</th>
                <th scope="col-2" class="text-center">Usuario</th>
                <th scope="col-3" class="text-center">Acción</th>
                <th scope="col-4" class="text-center">Observaciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let h of HistorialActivacion | paginate:{ itemsPerPage: 10, currentPage: page }">
                <td>{{h.fecha | date:"medium"}}</td>
                <td>{{h.usuarioMod}}</td>
                <td>{{h.accion}}</td>
                <td>{{h.observacion}}</td>
              </tr>
            </tbody>
          </table>
          <div class="row justify-content-end">
            <div class="col-auto"><pagination-controls (pageChange)="page = $event" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls></div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" #closeModalHistorial data-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>
